module.exports = __webpack_public_path__ + "ma.svg?f1e73245fb630eece28d17ff2d81e915";